import { z } from 'zod';
import { objectiveSubjectSchema, objectiveViewAddressSchema, objectiveSavedReadAddressSchema }
  from './objective-contract.schema';

/** Compatibility path for the types-first handoff; runtime schemas have one authority. */
export { objectiveIdentitySchema, objectivePeriodSchema, objectiveSourceSchema,
  objectiveCutDescriptorSchema, objectiveViewAddressSchema, objectiveSavedReadAddressSchema }
  from './objective-contract.schema';
export { objectiveSubjectSchema as objectiveInvestigationSubjectSchema } from './objective-contract.schema';

/** Full reads validate the cut here; compact reads require authorized cut resolution by the reader. */
export const objectiveInvestigationTargetSchema = z.object({ subject: objectiveSubjectSchema,
  address: z.union([objectiveViewAddressSchema, objectiveSavedReadAddressSchema]) }).strict()
  .refine(value => value.subject.ref === value.address.goalVersionRef
    && (!('figureCut' in value.address) || value.subject.tenantId === value.address.figureCut.identity.tenantId
      && value.subject.strategyId === value.address.figureCut.identity.strategyId
      && value.subject.scopeRef === value.address.figureCut.identity.scopeRef));
